export default __webpack_public_path__ + "3931d3343b602c579ff8756f4f230451.png";